import { render, staticRenderFns } from "./ques-textarea.vue?vue&type=template&id=16948b22&scoped=true"
import script from "./ques-textarea.vue?vue&type=script&lang=js"
export * from "./ques-textarea.vue?vue&type=script&lang=js"
import style0 from "./ques-textarea.vue?vue&type=style&index=0&id=16948b22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16948b22",
  null
  
)

export default component.exports